import { api_v1, setAxiosHeaders } from "utils/api-client";
import auth from "utils/auth-client";
import { identify } from "utils/analytics";

/**
 * Get all users
 */

export function getUserProfile() {
  const globalPromise = api_v1.get("/settings/global");
  const userPromise = api_v1.get("/users/me");
  const organizationPromise = api_v1.get("/users/me/organizations");
  const promiseAll = Promise.all([
    globalPromise,
    userPromise,
    organizationPromise,
  ]);
  return promiseAll.then(
    ([
      {
        data: {
          context: { relatedProgrammerList: programmers },
        },
      },
      { data: userContext },
      {
        data: { organizations },
      },
    ]) => {
      setAxiosHeaders({
        "organization-id": organizations[0].organizationId,
      });
      return Object.assign({}, userContext, {
        programmers,
        organizations,
      });
    }
  );
}

export function login(username, password) {
  const params = {
    email: username,
    password: password,
  };

  return auth
    .post("/login", params)
    .then(getUserProfile)
    .then((profile) => {
      identify(profile);
      return profile;
    });
}

export function logout() {
  return auth.post("/logout");
}
